import { useMemo } from 'react';

export const useIsMac = () => {
  return useMemo(
    () =>
      typeof window !== 'undefined'
        ? navigator.userAgent.toUpperCase().indexOf('MAC') >= 0
        : false,
    [],
  );
};
